import { z } from 'zod';
import { decodeHtmlEntities } from '@utils/common';
import { bindInputMaker } from '../util.make-input.js';

const makeInput = bindInputMaker();
const sentenceInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("sentence").default("sentence"),
      index: z.number().default(0)
    }),
    shouldValidate: node => !node.options.fixed,
    validate: (node, entry) => node.validation.expectedIndices.includes(entry.index),
    parseLegacyDetailItem: (item, context) => {
      if (context.relatedTask.taskType === "Sequence" && context.relatedTask.answerType === "Sentence" && typeof item === "number") {
        return [context.relatedInput?.id ?? `${context.relatedTask.id}-${context.indexInDetails}`, {
          type: "sentence",
          index: item
        }];
      }
    }
  },
  schema: z.object({
    text: z.string().transform(it => decodeHtmlEntities(it)),
    fixed: z.boolean()
  }),
  postprocessSchemaInput: (input, context) => {
    // NB: All positions that includes the text of the current input should be
    // considered valid when validating.
    const validIndices = context.arr.map((it, index) => ({
      ...it,
      index
    })).filter(it => !it.fixed && it.text === input.text).map(it => it.index);
    return {
      id: `${context.taskId}-${context.index}`,
      nodeType: "sentence-input",
      text: input.text,
      options: {
        fixed: input.fixed
      },
      validation: {
        expectedIndices: validIndices
      }
    };
  }
});

export { sentenceInput };
//# sourceMappingURL=input.sentence.js.map
